import MDinput from '@/components/MDinput';
import { validateEmail } from '@/utils/validate';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  const validateRequire = function(rule, value, callback) {
    if (!value) {
      callback(new Error(vue.$i18n.t('validation.required')));
    } else {
      callback();
    }
  };
  const validateRequireSelect = function(rule, value, callback) {
    if (value.length === 0) {
      callback(new Error(vue.$i18n.t('validation.required')));
    } else {
      callback();
    }
  };
  const validEmail = function(rule, value, callback) {
    if (value && !validateEmail(value)) {
      callback(new Error(vue.$i18n.t('validation.email')));
    } else {
      callback();
    }
  };
  return {
    id: {
      type: null,
      defaultValue: undefined
    },
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    },
    code: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        required: true,
        caption: 'login.code'
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    },
    email: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true,
        caption: 'common.email'
      },
      rules: [
        {
          validator: validateRequire
        },
        {
          validator: validEmail
        }
      ]
    },
    avatar: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        caption: 'user.avatar'
      }
    },
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255
      }
    },
    roles: {
      type: Select,
      defaultValue: [],
      props: {
        caption: 'user.roles',
        valueField: 'id',
        labelField: 'name',
        multiple: true,
        loading: vue.$store.getters['role/isLoading'],
        options: vue.$store.getters['role/loadedItems'],
        required: true
      },
      rules: [
        {
          validator: validateRequireSelect
        }
      ]
    }
  };
}

export function createItemFromFormData(vue, form) {
  const user = {
    ...form,
    domainID: vue.$store.getters.domainID,
    roles: []
  };
  if (form.id) {
    user['id'] = form.id;
  }
  form.roles.forEach(roleID => {
    const role = vue.$store.getters['role/getLoadedItemByID'](roleID);
    user.roles.push(role);
  });
  return user;
}

export function createFormDataFromItem(vue, user) {
  const form = {
    ...user
  };
  form.roles = [];
  user.roles.forEach(role => {
    form.roles.push(role.id);
  });
  return form;
}
